import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/reports/general/jobMinutesReportActions'
import { Button, Form, Checkbox, AutoComplete, Input, Icon, Spin } from 'antd'
import _ from 'lodash'
import { convertToOption } from '../../../util'
import ListItems from '../../../components/reports/general/job-minutes-report/ListItems'
import queryString from 'qs'
import config from '../../../config'

const { API_BASE } = config

const propTypes = {}
const FormItem = Form.Item
const CheckboxGroup = Checkbox.Group

class JobMinutesReportContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      checkedList: [],
      checkAll: false,
      plainOptions: [
        'Follow Ups',
        'AIAs',
        'Payment Requests',
        'Invoices',
        'Drawings',
        'Material Requests',
        'Work Orders',
        'Change Orders',
        'Service Orders',
        'Repair Orders',
        'Driver Requests',
        'Transmittals',
        'RFIs',
        'Violations'
      ]
    }

    // get job list
    this.props.jobMinutesReportGetJobList({})
    // get asgineee list
    this.props.jobMinutesReportGetUserList({})
  }

  onChangeCheckboxGroup = checkedList => {
    this.setState({
      checkedList,
      checkAll: checkedList.length === this.state.plainOptions.length
    })
  }

  handleJobSearch = _.debounce(value => {
    this.props.jobMinutesReportGetJobList({
      filters: {
        name: value
      }
    })
  }, 500)

  handleUserSearch = _.debounce(value => {
    this.props.jobMinutesReportGetUserList({
      filters: {
        name: value
      }
    })
  }, 500)

  applyFilter = page => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      if (page) values.page = page
      this.props.jobMinutesReportGetFullReport({ filters: values })
    })
  }

  onCheckAllChange = e => {
    const { form } = this.props

    form.setFieldsValue({
      types: e.target.checked ? this.state.plainOptions : []
    })

    this.setState({
      checkedList: e.target.checked ? this.state.plainOptions : [],
      checkAll: e.target.checked
    })
  }

  printReport = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const params = _.omit(values, 'date_range')

      const qs = queryString.stringify(params)
      const url = `${API_BASE}/api/reports/general/job-minutes-report/print?${qs}`
      window.open(url, '_blank')
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    const jobListData = _.get(this.props, 'jobMinutesReportActions.jobList.data')
    const loadingJobList = _.get(this.props, 'jobMinutesReportActions.loadingJobList')

    const userListData = _.get(this.props, 'jobMinutesReportActions.userList.data')
    const loadingUserList = _.get(this.props, 'jobMinutesReportActions.loadingUserList')

    const loadingFullReport = _.get(this.props, 'jobMinutesReportActions.loadingFullReport')
    const fullReport = _.get(this.props, 'jobMinutesReportActions.fullReport.data')
    const reportPage = _.get(this.props, 'jobMinutesReportActions.fullReport.page')
    const reportPageCount = _.get(this.props, 'jobMinutesReportActions.fullReport.count')

    return (
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <div className="row">
          <div className="col-10">
            <h3>Job Minutes Report</h3>
          </div>
          <Button icon="printer" onClick={() => this.printReport()} />
        </div>
        <Form layout="vertical">
          <div className="row">
            <div className="col-2">
              <div className="row">
                <Spin spinning={loadingJobList}>
                  <FormItem label="Job">
                    {getFieldDecorator('job_id', {})(
                      <AutoComplete
                        onChange={this.handleJobSearch}
                        dataSource={convertToOption(jobListData)}
                        filterOption={(inputValue, option) =>
                          option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                          -1
                        }
                        placeholder="Search for a Job"
                      >
                        <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                      </AutoComplete>
                    )}
                  </FormItem>
                </Spin>
              </div>
              <div className="row">
                <Spin spinning={loadingUserList}>
                  <FormItem label="User">
                    {getFieldDecorator('user_id', {})(
                      <AutoComplete
                        onChange={this.handleUserSearch}
                        dataSource={convertToOption(userListData)}
                        filterOption={(inputValue, option) =>
                          option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                          -1
                        }
                        placeholder="Search for an Assignee"
                      >
                        <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                      </AutoComplete>
                    )}
                  </FormItem>
                </Spin>
              </div>
            </div>
            <div className="col-10">
              <FormItem label="Select types:">
                {getFieldDecorator('types', {
                  initialValue: this.state.checkedList
                })(
                  <CheckboxGroup
                    options={this.state.plainOptions}
                    onChange={this.onChangeCheckboxGroup}
                    className="open-container-row"
                  />
                )}
              </FormItem>
              <div style={{ borderTop: '1px solid #E9E9E9' }}>
                <Checkbox onChange={this.onCheckAllChange} checked={this.state.checkAll}>
                  Check all
                </Checkbox>
              </div>
            </div>
          </div>
          <Button type="primary" onClick={() => this.applyFilter()}>
            Submit
          </Button>
        </Form>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <ListItems
              page={reportPage}
              pageCount={reportPageCount}
              fullReport={fullReport}
              loadingFullReport={loadingFullReport}
              onPageChange={this.applyFilter}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ jobMinutesReportActions, authentication }, ownProps) => ({
  jobMinutesReportActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions), dispatch)
})

JobMinutesReportContainer.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobMinutesReportContainer))
)



// WEBPACK FOOTER //
// ./src/containers/reports/general/JobMinutesReportContainer.js